const Contact = () => {
  return (
    <div className="section cc-contact">
      <div className="container">
        <div className="contact">
          <div className="contact-headline">
            <h3 className="heading">
              <strong></strong>Please email hi@smartgirlshq.com with any
              questions.{" "}
            </h3>
            <p className="paragraph-light">
              This study is <strong>supported by NSF Award #2036494.</strong>
            </p>
          </div>
          <div className="contact-form-wrap"></div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
